import { render, staticRenderFns } from "./Uploadimg.vue?vue&type=template&id=e9bbff78&scoped=true&"
import script from "./Uploadimg.vue?vue&type=script&lang=js&"
export * from "./Uploadimg.vue?vue&type=script&lang=js&"
import style0 from "./Uploadimg.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Uploadimg.vue?vue&type=style&index=1&id=e9bbff78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bbff78",
  null
  
)

export default component.exports